import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const baseRoutes = [
  {
    path: '/login',
    component: () => import('./views/Login.vue'),
    name: '',
    hidden: true
  },
  {
    path: '/404',
    component: () => import('./views/404.vue'),
    name: '',
    hidden: true
  }
]

const route404 = {
  path: '*',
  hidden: true,
  redirect: { path: '/404' }
}

// 创建路由方法
const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: baseRoutes
})

const router = createRouter()

// 重置路由
export function resetRouter () {
  var newRouter = createRouter()
  router.matcher = newRouter.matcher
}

router.onReady(() => {
  // 页面刷新加载动态路由
  var menuList = sessionStorage.getItem('menuList')
  if (menuList) {
    var menuObj = JSON.parse(menuList)
    var userRoutes = formatMenuToRouter(menuObj)
    router.addRoutes(userRoutes)
  }
})

export function formatMenuToRouter (menuList) {
  var userRoutes = []
  for (var i = 0; i < menuList.length; i++) {
    var menu = menuList[i]
    var userRoute = dealMenuToRouter(menu)
    userRoutes.push(userRoute)
  }
  // 统一404页面错误 放到最后，防止刷新直接404
  userRoutes.push(route404)
  return userRoutes
}

function dealMenuToRouter (menu) {
  var userRoute = {
    path: menu.path,
    component: () => import('@/views/' + menu.component),
    name: menu.menuName,
    iconCls: menu.icon
  }
  if (menu.menuName === '首页' && menu.path === '/') {
    userRoute.leaf = true
  }
  if (menu.sonList != null && menu.sonList.length > 0) {
    var children = []
    for (var i = 0; i < menu.sonList.length; i++) {
      var sonMenu = menu.sonList[i]
      var sonRoute = dealMenuToRouter(sonMenu)
      children.push(sonRoute)
    }
    userRoute.children = children
  }
  return userRoute
}

export default router
